import { AppRoute } from '@/constants/app-routes.ts';
import {
    CAREVIEW_FOOTER_LINKS,
    CONNECT_FOOTER_LINKS,
    DEFAULT_FOOTER_LINKS,
    EXTRACTION_FOOTER_LINKS,
    RECALL_FOOTER_LINKS,
} from '@/constants/external-links.ts';

import { FooterLink } from '@/models/footer-link.ts';

const isWithin = (pathname: string, route: AppRoute): boolean =>
    pathname === `${route}` || pathname.startsWith(`${route}/`);

// Picks the footer links for the current page; `AuthenticatedLayout` renders the single footer
export const getFooterLinks = (pathname: string): FooterLink[] => {
    if (isWithin(pathname, AppRoute.RECALL)) return RECALL_FOOTER_LINKS;
    if (isWithin(pathname, AppRoute.CONNECT)) return CONNECT_FOOTER_LINKS;
    if (isWithin(pathname, AppRoute.EXTRACTION)) return EXTRACTION_FOOTER_LINKS;
    if (isWithin(pathname, AppRoute.CAREVIEW)) return CAREVIEW_FOOTER_LINKS;
    return DEFAULT_FOOTER_LINKS;
};
